const dateFormat = { day: '2-digit', month: '2-digit', year: 'numeric' } as any
const dateTimeFormat = { ...dateFormat, hour: '2-digit', minute: '2-digit' } as any

export const genDateFormatProps = (t?: Function) => ({
    dataType: 'date' as ('string' | 'number' | 'date' | 'boolean' | 'object' | 'datetime'),
    format: t ? t('global:format.datetimeFormat', { context: 'date' }) : dateFormat,
    alignment: 'right' as ('center' | 'left' | 'right' | undefined),
})

export const genDateTimeFormatProps = (t?: Function) => ({
    dataType: 'datetime' as ('string' | 'number' | 'date' | 'boolean' | 'object' | 'datetime'),
    format: t ? t('global:format.datetimeFormat', { context: 'datetime' }) : dateTimeFormat,
    alignment: 'right' as ('center' | 'left' | 'right' | undefined),
})
